import { useTranslation } from 'react-i18next';
import BillingTimeline from "./BillingTimeline";

const ClientBillingSummary = () => {
  const { t } = useTranslation();
  const billing = {
    total: 5000,
    paid: 2500,
    pending: 2500,
    retainer: 2500,
    interval: "1.5 weeks",
    nextDue: "2025-07-02",
    status: "Partially Paid",
  };

  const handlePayNow = async () => {
    try {
      const res = await fetch("/api/stripe/create-checkout-session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: billing.pending, 
          clientId: 455,
          caseId: "47172c2a010bfc52489d68f9cd41c09faeb557f6c0edde72",
        }),
      });

      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert(t("Unable to create checkout session."));
      }
    } catch (error) {
      console.error("Stripe Checkout Error:", error);
      alert(t("Something went wrong."));
    }
  };

  return (
    <div className="glass rounded-lg shadow-sm p-6">
      <h2 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
        {t('Client billing summary')}
      </h2>

      <dl className="grid grid-cols-2 gap-x-4 gap-y-3 text-sm text-gray-700 dark:text-gray-300">
        <div>
          <dt className="font-medium">{t('Total agreed')}</dt>
          <dd>${billing.total.toLocaleString()}</dd>
        </div>
        <div>
          <dt className="font-medium">{t('Paid')}</dt>
          <dd>${billing.paid.toLocaleString()}</dd>
        </div>
        <div>
          <dt className="font-medium">{t('Pending')}</dt>
          <dd>${billing.pending.toLocaleString()}</dd>
        </div>
        <div>
          <dt className="font-medium">{t('Next due')}</dt>
          <dd>{billing.nextDue}</dd>
        </div>
        <div>
          <dt className="font-medium">{t('Interval')}</dt>
          <dd>{billing.interval}</dd>
        </div>
        <div>
          <dt className="font-medium">{t('Status')}</dt>
          <dd>
            <span
              className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${
                billing.status === "Partially Paid"
                  ? "bg-warning-100 text-warning-800 dark:bg-warning-900 dark:text-warning-300"
                  : billing.status === "Fully Paid"
                  ? "bg-success-100 text-success-800 dark:bg-success-900 dark:text-success-300"
                  : "bg-danger-100 text-danger-800 dark:bg-danger-900 dark:text-danger-300"
              }`}
            >
              {t(billing.status)}
            </span>
          </dd>
        </div>
      </dl>

      <div className="mt-6">
        <BillingTimeline paid={billing.paid} total={billing.total} />
      </div>

      {billing.pending > 0 && (
        <div className="mt-6">
          <button
            onClick={handlePayNow}
            className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-info-600 hover:bg-info-700 rounded-md transition"
          >
            {t('Pay now')}
          </button>
        </div>
      )}
    </div>
  );
};

export default ClientBillingSummary;
